
export const FacebookSquareIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 24H12V15.75H9V12H12V9C12 6.514 14.014 4.5 16.5 4.5H19.5V8.25H18C17.172 8.25 16.5 8.172 16.5 9V12H20.25L18.75 15.75H16.5V24H21C22.654 24 24 22.654 24 21V3C24 1.345 22.654 0 21 0H3C1.345 0 0 1.345 0 3V21C0 22.654 1.345 24 3 24Z" fill="#517FF5"/>
  </svg>
);
